module.exports = __webpack_public_path__ + "img/Templates-Header.e09b817e.png";